import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'app-friend',
  templateUrl: './friend.component.html',
})
export class FriendComponent {
  @Input() friends;
  @Output() onChatOn = new EventEmitter();

  public innerChatToggle(id) {
    this.onChatOn.emit();
  }

}
